import React from 'react';
import { StyleSheet, View } from 'react-native';
import { radii } from '../../domain/tokens';
import { CompassCore } from '../CompassView';
import type { OrderWidgetProps } from './types';

// No fixed height: CompassCore sizes its own stage to the current tilt/zoom,
// project depth, and whether an orb is open — the widget follows it, growing
// and shrinking with the compass instead of reserving the worst case forever.
export function AstraWidget({ userId, gear, data, onOpen }: OrderWidgetProps) {
  return (
    <View style={styles.container}>
      <CompassCore userId={userId} onOpenTool={() => onOpen()} compact={true} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: radii.tile,
    overflow: 'hidden',
  },
});
